import api from './api';

export const authService = {
  /**
   * Connexion utilisateur
   * @param {string} email
   * @param {string} motDePasse
   * @returns {Promise}
   */
  login: async (email, motDePasse) => {
    try {
      const response = await api.post('/auth/login', { email, motDePasse });
      const { access_token, user } = response.data;

      // Stocker le token et les infos utilisateur
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('user', JSON.stringify(user));

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la connexion:', error);
      throw error;
    }
  },

  /**
   * Inscription (Admin uniquement)
   * @param {Object} userData - Données de l'utilisateur
   * @returns {Promise}
   */
  register: async (userData) => {
    try {
      const response = await api.post('/auth/register', userData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'inscription:', error);
      throw error;
    }
  },

  /**
   * Récupérer le profil de l'utilisateur connecté
   * @returns {Promise}
   */
  getProfile: async () => {
    try {
      const response = await api.get('/auth/profile');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du profil:', error);
      throw error;
    }
  },

  /**
   * Déconnexion
   */
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
  },

  /**
   * Vérifier si l'utilisateur est connecté
   * @returns {boolean}
   */
  isAuthenticated: () => {
    return !!localStorage.getItem('access_token');
  },

  /**
   * Récupérer l'utilisateur courant
   * @returns {Object|null}
   */
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },
};

export default authService;
